{
  "faqs": [
    {
      "q": "What makes Gab AI different?",
      "a": "Gab AI’s in-house AI model is trained on Christian and conservative values. Select Gab AI when you want an assistant that respects that worldview. Gab AI also offers other models; their perspectives differ."
    },
    {
      "q": "What does the political compass show?",
      "a": "Gab AI ran the same {{QUESTIONS}}-question Political Compass questionnaire across the plotted models on {{TEST_DATE}}. Gab AI is on the economic right; every other model in this published comparison is on the economic left. Gab AI used Gab’s product prompting, while the others used provider defaults without an added political prompt. The chart is a snapshot of those answers, not a universal claim about every model or response."
    },
    {
      "q": "Can our whole church join as an organization?",
      "a": "Gab AI for Business supports teams of 2–250 seats, including churches and ministries. Mix Plus and Plus Premium seats, pool included credits, and manage your organization on the website. The Business page shows current enrollment availability and setup details."
    },
    {
      "q": "What can an administrator control?",
      "a": "Owners manage paid seats, view organization and member usage, and set spending limits. Admins help manage the team. Organization membership does not make members’ private chats and files visible to administrators."
    },
    {
      "q": "Does AI replace pastoral judgment?",
      "a": "No. Use it for preparation, ideas, and first drafts. Your ministry reviews Scripture references, theology, facts, and sensitive communications before sharing them. Keep pastoral care and final decisions with your people."
    }
  ],
  "tools": [
    {
      "icon": "bullhorn",
      "name": "Church Announcement Writer",
      "desc": "Spoken, bulletin, email, and social announcements from verified ministry details"
    },
    {
      "icon": "newspaper",
      "name": "Church Newsletter Writer",
      "desc": "Skimmable newsletters from updates, events, prayer points, and calls to action"
    },
    {
      "icon": "list-check",
      "name": "Ministry Event Planner",
      "desc": "Timelines, staffing maps, run sheets, and follow-up for church and ministry events"
    },
    {
      "icon": "users",
      "name": "Church Volunteer Coordinator",
      "desc": "Role briefs, recruiting copy, onboarding steps, schedules, and appreciation follow-up"
    },
    {
      "icon": "globe",
      "name": "Ministry Outreach Planner",
      "desc": "Needs-led community outreach plans with partners, logistics, consent, and follow-up"
    },
    {
      "icon": "gift",
      "name": "Church Donor Writer",
      "desc": "Thank-you notes, campaign updates, impact reports, and giving appeals from verified facts"
    },
    {
      "icon": "comments",
      "name": "Small Group Discussion Guide",
      "desc": "Facilitator-ready discussion plans with open questions, timing, and pastoral boundaries"
    },
    {
      "icon": "shield-check",
      "name": "Church Policy Drafter",
      "desc": "First drafts of church procedures, handbooks, and internal policies with review flags"
    }
  ],
  "examplePrompts": [
    {
      "title": "Outline a sermon",
      "prompt": "Help me outline a 30-minute sermon on forgiveness based on Matthew 18:21-35. Give me a central message, 3 main points with supporting scripture, an illustration for each, and a call to action.",
      "category": "sermons",
      "order": 10,
      "attachments": []
    },
    {
      "title": "Develop a sermon series",
      "prompt": "Help me plan a 5-week sermon series on the fruit of the Spirit. Give each week a theme, a key passage, a memorable title, and one practical takeaway for the congregation.",
      "category": "sermons",
      "order": 20,
      "attachments": []
    },
    {
      "title": "Write a small-group study guide",
      "prompt": "Create a small-group discussion guide based on this Sunday's message about trusting God in uncertainty. Include an icebreaker, 5 discussion questions, scripture, and a prayer prompt.",
      "category": "sermons",
      "order": 30,
      "attachments": [
        {
          "label": "SermonNotes.docx",
          "type": "file"
        }
      ]
    },
    {
      "title": "Find illustrations and cross-references",
      "prompt": "I'm preaching on grace from Ephesians 2:8-9. Suggest a few relatable real-life illustrations, helpful cross-references, and a clear way to explain grace to someone new to faith.",
      "category": "sermons",
      "order": 40,
      "attachments": []
    },
    {
      "title": "Write a daily devotional",
      "prompt": "Write a warm, encouraging 300-word daily devotional on finding peace in anxious times, anchored in Philippians 4:6-7. Include a short reflection, a practical step, and a closing prayer.",
      "category": "media",
      "order": 50,
      "attachments": []
    },
    {
      "title": "Create sermon slide graphics",
      "prompt": "Generate a clean, modern set of worship slide backgrounds for a series called 'Anchored'. Calm, hopeful, with a nautical-but-subtle feel and clear space for scripture text.",
      "category": "media",
      "order": 60,
      "attachments": []
    },
    {
      "title": "Generate worship music",
      "prompt": "Generate a gentle, reverent instrumental worship track suitable for a time of prayer and reflection: soft piano and ambient pads, peaceful and uplifting, around 3 minutes.",
      "category": "media",
      "order": 70,
      "attachments": []
    },
    {
      "title": "Create a ministry promo video",
      "prompt": "Create a short, inviting promo video concept for our upcoming youth retreat: warm and energetic, with suggested scenes, on-screen text, and a music vibe that appeals to teens and parents.",
      "category": "media",
      "order": 80,
      "attachments": []
    },
    {
      "title": "Write the weekly newsletter",
      "prompt": "Write our weekly church email newsletter: a brief encouraging note from the pastor, this week's announcements, upcoming events, volunteer needs, and a verse of the week.",
      "category": "communication",
      "order": 90,
      "attachments": []
    },
    {
      "title": "Draft announcements",
      "prompt": "Turn these event notes into clear, warm announcements for the bulletin and the Sunday slides: a community potluck, a baptism class, and a serve-day signup.",
      "category": "communication",
      "order": 100,
      "attachments": [
        {
          "label": "EventNotes.txt",
          "type": "file"
        }
      ]
    },
    {
      "title": "Write a welcome message",
      "prompt": "Write a friendly follow-up message to first-time guests who visited our church this Sunday. Make them feel genuinely welcomed, share next steps, and invite them back without pressure.",
      "category": "communication",
      "order": 110,
      "attachments": []
    },
    {
      "title": "Plan a volunteer appreciation",
      "prompt": "Help me write a heartfelt thank-you message to our volunteers and plan a simple appreciation event. Acknowledge their service, the difference they make, and make them feel valued.",
      "category": "communication",
      "order": 120,
      "attachments": []
    },
    {
      "title": "Plan a ministry event",
      "prompt": "Help me plan a church-wide fall festival for families on Saturday, October 18, 10 AM–2 PM on the lawn. Expected attendance is 200. Budget is $1,500 and we have 12 volunteers. Give me a timeline, staffing map, day-of run sheet, budget checklist, safeguarding prompts, and follow-up steps.",
      "category": "operations",
      "order": 130,
      "attachments": []
    },
    {
      "title": "Coordinate Sunday volunteers",
      "prompt": "We need greeters, kids-check-in hosts, and coffee-team leads for Sunday services. Draft role briefs, a recruiting message, onboarding steps, a fair monthly schedule, reminder copy, and a short appreciation note. Screening and two-adult rules apply for kids ministry.",
      "category": "operations",
      "order": 140,
      "attachments": []
    },
    {
      "title": "Plan a community outreach",
      "prompt": "Our neighborhood asked for a monthly food-share on Saturday mornings. We have a fellowship hall kitchen, 8 regular volunteers, and a $400/month grocery budget. Build a needs-led outreach plan with listening questions, partner roles, logistics, consent and privacy checks, and follow-up.",
      "category": "operations",
      "order": 150,
      "attachments": []
    },
    {
      "title": "Write a donor thank-you",
      "prompt": "Draft a thank-you email for a $2,500 designated gift to the youth summer camp scholarship fund. The gift is restricted to scholarships. Do not invent impact numbers. Keep it warm, specific, and free of pressure.",
      "category": "operations",
      "order": 160,
      "attachments": []
    },
    {
      "title": "Draft a church policy",
      "prompt": "Turn these leadership notes into a first-draft building-use policy for outside groups: purpose, who approves, insurance, keys, child-safety, cleanup, and a review cycle. Flag anything that needs legal or insurance review.",
      "category": "operations",
      "order": 170,
      "attachments": []
    }
  ],
  "relatedUseCases": [
    {
      "slug": "free-thinkers",
      "name": "Free Thinkers"
    },
    {
      "slug": "independent-media",
      "name": "Independent Media"
    },
    {
      "slug": "homeschoolers",
      "name": "Homeschool Families"
    },
    {
      "slug": "nonprofits",
      "name": "Nonprofits"
    }
  ],
  "seo": {
    "title": "AI for Churches & Ministries — Christian AI & Organization Plans | Gab AI",
    "description": "Meet Gab AI, Christian and conservative AI from Gab. Equip your church with ministry tools, shared credits, centralized billing, and team controls.",
    "ogImage": "/churches/ministry-film.jpg"
  }
}
